
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-sale",
      function () {
        return require("private-next-pages/private-sale/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-sale"])
      });
    }
  